<template>
<div class="chapter">
<div class="inner_page">
<section>
<h1 class="fmtitle1" epub:type="title"><span epub:type="pagebreak" id="page_vii" title="vii">Other “British” titles from</span></h1>
<figure><div class="image3"><img alt="image" src="images/pgvii.png"/></div></figure>
<p class="fmt"><span class="un">MICHAEL DAVID ANTHONY</span></p>
<p class="fm"><i>The Becket Factor</i></p>
<p class="fm"><i>Midnight Come</i></p>
<p class="fm"><i>Dark Provenance</i></p>
<p class="fmt"><span class="un">ROBERT BARNARD</span></p>
<p class="fm"><i>Corpse in a Gilded Cage</i></p>
<p class="fm"><i>Death and the Chaste Apprentice</i></p>
<p class="fm"><i>The Skeleton in the Grass</i></p>
<p class="fm"><i>Out of the Blackout</i></p>
<p class="fmt"><span class="un">SIMON BRETT</span></p>
<p class="fm"><i>Blotto, Twinks and the Ex-King’s Daughter</i></p>
<p class="fm"><i>Blotto, Twinks and the Dead Dowager Duchess</i></p>
<p class="fm"><i>Blotto, Twinks and the Rodents of the Riviera</i></p>
<p class="fm"><i>Blotto, Twinks and the Bootlegger’s Moll</i></p>
<p class="fmt"><span class="un">CAROLINE GRAHAM</span></p>
<p class="fm"><i>The Killings at Badger’s Drift</i></p>
<p class="fm"><i>Death of a Hollow Man</i></p>
<p class="fm"><i>Death in Disguise</i></p>
<p class="fm"><i>Written in Blood</i></p>
<p class="fm"><i>Murder at Madingley Grange</i></p>
<p class="fmt"><span class="un">ELIZABETH IRONSIDE</span></p>
<p class="fm"><i>The Accomplice</i></p>
<p class="fm"><i>The Art of Deception</i></p>
<p class="fm"><i>Death in the Garden</i></p>
<p class="fm"><i>A Very Private Enterprise</i></p>
<p class="fmt"><span class="un">MAGGIE JOEL</span></p>
<p class="fm"><i>The Second-Last Woman in England</i></p>
<p class="fm"><i>The Past and Other Lies</i></p>
<p class="fmt"><span class="un">SHEILA RADLEY</span></p>
<p class="fm"><i>Death in the Morning</i></p>
<p class="fm"><i>The Chief Inspector’s Daughter</i></p>
<p class="fm"><i>A Talent for Destruction</i></p>
<p class="fm"><i>Fate Worse than Death</i></p>
<p class="fmt"><span class="un">LESLIE THOMAS</span></p>
<p class="fm"><i>Dangerous Davies: The Last Detective</i></p>
<p class="fmt"><span class="un">L.C. TYLER</span></p>
<p class="fm"><i>The Herring Seller’s Apprentice</i></p>
<p class="fm"><i>Ten Little Herrings</i></p>
<p class="fm"><i>The Herring in the Library</i></p>
<p class="fm"><i>Herring on the Nile</i></p>
<p class="fm"><i>Crooked Herring</i></p>
<p class="pbreak">
</p><p> </p>
<p> </p>
<figure><div class="image"><span epub:type="pagebreak" id="page_ix" title="ix"><img alt="image" src="images/pgi.png"/></span></div></figure>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Fm03.vue?148db6be